export default "__VITE_ASSET__167a5a60__"